<template>
  <div>
    <el-row>
      <el-col>
        <span>图片列表: </span>
        <el-button
          v-if="!readonly"
          type="text"
          size="medium"
          @click="showImageUploader()"
        >点击上传图片</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div
          v-if="imageShowerVisible"
          v-loading="isLoading"
        >
          <el-row>
            <el-col
              v-for="(file, index) in dataModel.imageFiles"
              :key="index"
              class="cs-demo-image__lazy"
            >
              <div class="block">
                <a @click="showImagePreview(file.pictureUrl)">
                  <img
                    :src="__convertImageUrl(file.pictureUrl)"
                    lazy
                  >
                </a>
              </div>
              <el-button
                v-if="!readonly"
                type="text"
                size="medium"
                @click="removeImage(index)"
                v-show="imageShowerVisible"
              >删除</el-button>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <template>
      <el-dialog
        center
        title="上传图片"
        :show-close="true"
        :close-on-click-modal="false"
        width="700px"
        :visible.sync="imageUploaderVisible"
        top="8vh"
        z-index="2000"
      >
        <blob-uploader
          @closeEditor="onCloseImageUploader"
          @blobUploadError="onImageUploadError"
          @blobUploaded="onImageUploaded"
          :type="7"
          :accepts="'.png,.jpg,.jpeg'"
          :isVisible="imageUploaderVisible"
          :isAutoSave="false"
          :isMulti="true"
        ></blob-uploader>
      </el-dialog>
      <el-dialog
        center
        title="图片预览"
        :show-close="true"
        :close-on-click-modal="false"
        width="700px"
        :visible.sync="imagePreviewVisible"
        top="8vh"
        z-index="2000"
      >
        <div class="cs-demo-image-preview__lazy">
          <div class="block">
            <img
              :src="dataModel.previewImageSrc"
              lazy
            >
          </div>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.cs-demo-image__lazy {
  width: 140px;
  .block {
    width: 128px;
    height: 128px;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}

.cs-demo-image-preview__lazy {
  .block {
    text-align: center;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
</style>

<script>
import blobUploader from "@/components/fileHandler/blobUploader";

import { getSharedAccessSignature } from "../../service/blobStorage.service";
import {
  getFileStorageListByWorkflowId,
  saveWorkflowImageFiles,
  removeWorkflowImageFile
} from "@/service/blobStorage.service";

export default {
  props: {
    readonly:Boolean,
    data: {
      workflowId: Number
    }
  },
  data() {
    return {
      isLoading: false,
      sasKey: "",
      imageUploaderVisible: false,
      imageShowerVisible: false,
      imagePreviewVisible: false,
      dataModel: {
        workflowId: 0,
        imageFiles: [],
        previewImageSrc: ""
      }
    };
  },
  created() {
    this.init();
  },
  components: {
    blobUploader
  },
  computed: {},
  methods: {
    loadSharedAccessSignatureFromServer() {
      this.isLoading = true;
      getSharedAccessSignature(true)
        .then(result => {
          if (!!result && result.success) {
            this.sasKey = result.data;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    async loadImageFilesDataFromServer() {
      this.dataModel.imageFiles = [];
      if (!this.dataModel.workflowId) {
        return;
      }

      let result = await getFileStorageListByWorkflowId(
        this.dataModel.workflowId
      );
      if (!!result && result.success) {
        result.data.forEach(fileStorage => {
          this.dataModel.imageFiles.push({
            fileId: fileStorage.Id,
            pictureUrl: fileStorage.Path
          });
        });
      }

      this.imageShowerVisible = this.dataModel.imageFiles.length > 0;
    },
    reloadDataModel(data) {
      if (!data) data = this.data;

      if (!!data) {
        this.dataModel.workflowId = data.workflowId;
      } else {
        this.dataModel.workflowId = 0;
      }
    },
    async init() {
      this.loadSharedAccessSignatureFromServer();
      this.reloadDataModel();
      await this.loadImageFilesDataFromServer();
    },
    showImageUploader() {
      this.imageUploaderVisible = true;
    },
    closeImageUploader() {
      this.imageUploaderVisible = false;
    },
    showImagePreview(pictureUrl) {
      this.dataModel.previewImageSrc = this.__convertImageUrl(pictureUrl);
      this.imagePreviewVisible = true;
    },
    closeImagePreview() {
      this.imagePreviewVisible = false;
    },
    removeImage(index) {
      if (!this.dataModel.workflowId) return;

      this.$confirm("您确认要删除该图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          removeWorkflowImageFile(
            this.dataModel.workflowId,
            this.dataModel.imageFiles[index].fileId
          ).then(result => {
            if (!!result && result.success) {
              this.dataModel.imageFiles.splice(index, 1);
            }
          });
        })
        .catch(() => {});
    },
    onCloseImageUploader() {
      this.closeImageUploader();
    },
    onImageUploadError() {},
    onImageUploaded(data) {
      if (!this.dataModel.workflowId || !data || data.length === 0) {
        this.imageShowerVisible = true;
        this.imageUploaderVisible = false;
        return;
      }

      saveWorkflowImageFiles(this.dataModel.workflowId, data)
        .then(result => {
          if (!!result && result.success) {
            result.data.forEach(file => {
              this.dataModel.imageFiles.push({
                fileId: file.FileId,
                pictureUrl: file.Path
              });
            });
          } else {
            this.$message.error("图片上传失败");
          }
          this.imageShowerVisible = true;
          this.imageUploaderVisible = false;
        })
        .catch(err => {
          this.imageShowerVisible = true;
          this.imageUploaderVisible = false;
        });
    },
    __convertImageUrl(originalUrl) {
      if (!this.sasKey) {
        return "";
      }

      return originalUrl + this.sasKey;
    }
  },
  watch: {
    data: function(newVal) {
      this.reloadDataModel(newVal);
      this.loadImageFilesDataFromServer();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/workflowImageList.vue